/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CallSession,
  CreateCall201Response,
  CreateCallSessionDto,
  DeleteCallSessionsByIdsRequest,
  DispatchCallSessionsDto,
  UpdateCallComment200Response,
  UpdateCallSessionDto,
} from '../models/index';
import {
    CallSessionFromJSON,
    CallSessionToJSON,
    CreateCall201ResponseFromJSON,
    CreateCall201ResponseToJSON,
    CreateCallSessionDtoFromJSON,
    CreateCallSessionDtoToJSON,
    DeleteCallSessionsByIdsRequestFromJSON,
    DeleteCallSessionsByIdsRequestToJSON,
    DispatchCallSessionsDtoFromJSON,
    DispatchCallSessionsDtoToJSON,
    UpdateCallComment200ResponseFromJSON,
    UpdateCallComment200ResponseToJSON,
    UpdateCallSessionDtoFromJSON,
    UpdateCallSessionDtoToJSON,
} from '../models/index';

export interface CreateCallSessionsRequest {
    createCallSessionDto: Array<CreateCallSessionDto>;
}

export interface DeleteCallSessionRequest {
    callSessionId: number;
}

export interface DeleteCallSessionsByIdsOperationRequest {
    deleteCallSessionsByIdsRequest: DeleteCallSessionsByIdsRequest;
}

export interface DispatchCallSessionsRequest {
    dispatchCallSessionsDto: DispatchCallSessionsDto;
}

export interface GetByCampaignIdRequest {
    campaignId: number;
}

export interface UpdateCallSessionRequest {
    callSessionId: number;
    updateCallSessionDto: UpdateCallSessionDto;
}

/**
 * 
 */
export class CallSessionApi extends runtime.BaseAPI {

    /**
     * Create new call-sessions
     */
    async createCallSessionsRaw(requestParameters: CreateCallSessionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CreateCall201Response>>> {
        if (requestParameters['createCallSessionDto'] == null) {
            throw new runtime.RequiredError(
                'createCallSessionDto',
                'Required parameter "createCallSessionDto" was null or undefined when calling createCallSessions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/call-session`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['createCallSessionDto']!.map(CreateCallSessionDtoToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CreateCall201ResponseFromJSON));
    }

    /**
     * Create new call-sessions
     */
    async createCallSessions(requestParameters: CreateCallSessionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CreateCall201Response>> {
        const response = await this.createCallSessionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a call-session
     */
    async deleteCallSessionRaw(requestParameters: DeleteCallSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateCallComment200Response>> {
        if (requestParameters['callSessionId'] == null) {
            throw new runtime.RequiredError(
                'callSessionId',
                'Required parameter "callSessionId" was null or undefined when calling deleteCallSession().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/call-session/{callSessionId}`;
        urlPath = urlPath.replace(`{${"callSessionId"}}`, encodeURIComponent(String(requestParameters['callSessionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateCallComment200ResponseFromJSON(jsonValue));
    }

    /**
     * Delete a call-session
     */
    async deleteCallSession(requestParameters: DeleteCallSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateCallComment200Response> {
        const response = await this.deleteCallSessionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete call-sessions by IDs
     */
    async deleteCallSessionsByIdsRaw(requestParameters: DeleteCallSessionsByIdsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateCallComment200Response>> {
        if (requestParameters['deleteCallSessionsByIdsRequest'] == null) {
            throw new runtime.RequiredError(
                'deleteCallSessionsByIdsRequest',
                'Required parameter "deleteCallSessionsByIdsRequest" was null or undefined when calling deleteCallSessionsByIds().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/call-session`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: DeleteCallSessionsByIdsRequestToJSON(requestParameters['deleteCallSessionsByIdsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateCallComment200ResponseFromJSON(jsonValue));
    }

    /**
     * Delete call-sessions by IDs
     */
    async deleteCallSessionsByIds(requestParameters: DeleteCallSessionsByIdsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateCallComment200Response> {
        const response = await this.deleteCallSessionsByIdsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Dispatch call-sessions
     */
    async dispatchCallSessionsRaw(requestParameters: DispatchCallSessionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateCallComment200Response>> {
        if (requestParameters['dispatchCallSessionsDto'] == null) {
            throw new runtime.RequiredError(
                'dispatchCallSessionsDto',
                'Required parameter "dispatchCallSessionsDto" was null or undefined when calling dispatchCallSessions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/call-session/dispatch`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DispatchCallSessionsDtoToJSON(requestParameters['dispatchCallSessionsDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateCallComment200ResponseFromJSON(jsonValue));
    }

    /**
     * Dispatch call-sessions
     */
    async dispatchCallSessions(requestParameters: DispatchCallSessionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateCallComment200Response> {
        const response = await this.dispatchCallSessionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get calls session by campaign id
     */
    async getByCampaignIdRaw(requestParameters: GetByCampaignIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CallSession>>> {
        if (requestParameters['campaignId'] == null) {
            throw new runtime.RequiredError(
                'campaignId',
                'Required parameter "campaignId" was null or undefined when calling getByCampaignId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/call-session/campaign/{campaignId}`;
        urlPath = urlPath.replace(`{${"campaignId"}}`, encodeURIComponent(String(requestParameters['campaignId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CallSessionFromJSON));
    }

    /**
     * Get calls session by campaign id
     */
    async getByCampaignId(requestParameters: GetByCampaignIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CallSession>> {
        const response = await this.getByCampaignIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a call-session
     */
    async updateCallSessionRaw(requestParameters: UpdateCallSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UpdateCallComment200Response>> {
        if (requestParameters['callSessionId'] == null) {
            throw new runtime.RequiredError(
                'callSessionId',
                'Required parameter "callSessionId" was null or undefined when calling updateCallSession().'
            );
        }

        if (requestParameters['updateCallSessionDto'] == null) {
            throw new runtime.RequiredError(
                'updateCallSessionDto',
                'Required parameter "updateCallSessionDto" was null or undefined when calling updateCallSession().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/call-session/{callSessionId}`;
        urlPath = urlPath.replace(`{${"callSessionId"}}`, encodeURIComponent(String(requestParameters['callSessionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCallSessionDtoToJSON(requestParameters['updateCallSessionDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UpdateCallComment200ResponseFromJSON(jsonValue));
    }

    /**
     * Update a call-session
     */
    async updateCallSession(requestParameters: UpdateCallSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UpdateCallComment200Response> {
        const response = await this.updateCallSessionRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
